import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { readAnalyticsConsent, subscribeAnalyticsConsent, hasConsentStorageFailure } from '../lib/analyticsConsent';
import { startGa4, stopGa4, trackPageView } from '../lib/ga4';
import { PRIVACY_PATH } from '../content/legal';

export const AnalyticsController = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const reconcile = () => {
      if (readAnalyticsConsent() === 'granted') {
        if (['/', PRIVACY_PATH].includes(pathname) && startGa4()) trackPageView();
      } else {
        const wasStarted = stopGa4();
        // Removing the script alone cannot unload Google's listeners. Reload only
        // after persistence succeeds, so a stale grant cannot be restored.
        if (wasStarted && !hasConsentStorageFailure()) window.location.reload();
      }
    };
    return subscribeAnalyticsConsent(reconcile);
  }, [pathname]);

  return null;
};